import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoneyBillWave, faUserTie } from '@fortawesome/free-solid-svg-icons';
import api from '../../Api';
import SearchableSelect from '../../components/SearchableSelect';
import SupervisorPayments from './SupervisorPayments';

// CT / admin view: pick any prestataire (supervisor) and see their full payment history,
// reusing the same rendering as the supervisor's own /f2f/my-payments page.
const PrestatairePayments = () => {
    const [supervisors, setSupervisors] = useState([]);
    const [selectedId, setSelectedId] = useState(null);
    const [loadingList, setLoadingList] = useState(true);

    useEffect(() => {
        const fetchSupervisors = async () => {
            try {
                setLoadingList(true);
                const res = await api.get('/supervisors');
                const list = Array.isArray(res.data) ? res.data : (res.data.data || []);
                setSupervisors(list);
            } catch (e) {
                console.error('Error fetching supervisors:', e);
            } finally {
                setLoadingList(false);
            }
        };
        fetchSupervisors();
    }, []);

    return (
        <div className="min-h-screen bg-gray-50 p-4 sm:p-6 lg:p-8">
            <div className="max-w-7xl mx-auto">
                {/* Header */}
                <div className="mb-6">
                    <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2 flex items-center gap-3">
                        <FontAwesomeIcon icon={faMoneyBillWave} className="text-red-600" />
                        Paiements des Prestataires
                    </h1>
                    <p className="text-gray-600">Consultez l'intégralité de l'historique de paiement d'un prestataire.</p>
                </div>

                {/* Prestataire selector */}
                <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-200 mb-6 max-w-md">
                    <label className="block text-sm font-medium text-gray-700 mb-1 flex items-center gap-2">
                        <FontAwesomeIcon icon={faUserTie} className="text-gray-400" />
                        Prestataire
                    </label>
                    <SearchableSelect
                        options={supervisors}
                        selectedValue={selectedId}
                        onChange={(id) => setSelectedId(id)}
                        getOptionLabel={(o) => (o.ref ? `${o.name} (${o.ref})` : o.name)}
                        showOptionMeta={false}
                        placeholder={loadingList ? 'Chargement...' : 'Sélectionner un prestataire...'}
                        searchPlaceholder="Rechercher un prestataire..."
                    />
                </div>

                {/* Payment history (reused component, embedded = no page chrome) */}
                {selectedId ? (
                    <SupervisorPayments supervisorId={selectedId} embedded canOpenBatch />
                ) : (
                    <div className="bg-white rounded-xl p-12 shadow-sm border border-gray-200 text-center text-gray-500">
                        Sélectionnez un prestataire pour voir ses paiements.
                    </div>
                )}
            </div>
        </div>
    );
};

export default PrestatairePayments;
